import React, { Component } from 'react';

class Head extends Component {
    render() {
        return (
           <thead>
            <tr>
                <th className="w-50 a-center">ID</th>
                <th>Description</th>   
                <th>Category</th>
                <th>City</th>
                <th>District</th>
                <th>Ward</th>
                <th>Total</th>
                <th className="w-60 a-center">Edit</th>
            </tr>
            </thead> 
        );
    }
}

export default Head;